import { useState } from "react";
import { subscribe } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function NewsletterCTA() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [cityState, setCityState] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await subscribe({ name: name || null, email, city_state: cityState || null });
      toast.success("Bem-vindo à comunidade ROTTA!", {
        description: "Você receberá nossas próximas rotas em primeira mão.",
      });
      setName(""); setEmail(""); setCityState("");
    } catch (err) {
      toast.error("Não conseguimos cadastrar agora. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="newsletter"
      data-testid="newsletter-section"
      className="section relative overflow-hidden grain"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-25"
        style={{
          background:
            "radial-gradient(ellipse at top, rgba(198,167,98,0.18), transparent 60%), radial-gradient(ellipse at bottom, rgba(85,99,57,0.18), transparent 60%)",
        }}
      />
      <div className="container-rotta relative">
        <div className="card-rotta p-8 md:p-14 grid lg:grid-cols-2 gap-10 items-center bg-gradient-to-br from-[#181818] to-[#101010]">
          <div>
            <div className="flex items-center gap-2 text-[#C6A762] mb-5">
              <span className="gold-divider" />
              <span className="text-[11px] tracking-[0.3em] uppercase">Comunidade ROTTA</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
              Entre para a tribo de quem
              <br />
              <span className="text-gold-gradient">vive a estrada.</span>
            </h2>
            <p className="text-[#B8B8B8] mt-5 max-w-xl text-base leading-relaxed">
              Receba rotas verificadas, eventos exclusivos e conteúdos selecionados em primeira
              mão. Sem spam, só o que importa para quem ama duas rodas.
            </p>
          </div>

          <form onSubmit={submit} className="space-y-4" data-testid="newsletter-form">
            <div className="grid gap-4">
              <input
                data-testid="newsletter-name"
                className="input-rotta"
                placeholder="Seu nome"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                data-testid="newsletter-email"
                type="email"
                required
                className="input-rotta"
                placeholder="Seu e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                data-testid="newsletter-city-state"
                className="input-rotta"
                placeholder="Cidade/Estado — ex: Belo Horizonte/MG"
                value={cityState}
                onChange={(e) => setCityState(e.target.value)}
              />
            </div>
            <button
              data-testid="newsletter-submit"
              disabled={loading}
              type="submit"
              className="btn-gold w-full py-4 rounded-full text-xs flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {loading ? "Enviando..." : "Entrar para a comunidade"} <ArrowRight size={14} />
            </button>
            <p className="text-[11px] text-[#7d7d7d] tracking-wide leading-relaxed pt-2">
              Ao se cadastrar você concorda em receber comunicações da ROTTA. Você pode
              cancelar quando quiser.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}
